// src/components/Users.js

import React from 'react';
import Navbar from './Navbar';
import '../styles/Users.css';

const Users = ({ onLogout }) => {
  return (
    <div className="users">
      <Navbar onLogout={onLogout} />
      <div className="content">
        <h1>Users</h1>
        {/* Add your Users component content here */}
      </div>
    </div>
  );
};

export default Users;